import { Android24 } from 'ui/icons/devices/Android24';
import { Apple24 } from 'ui/icons/devices/Apple24';

export const VIEW_OPTIONS = [
  { name: <Apple24 />, key: 'apple', value: 'apple' },
  { name: <Android24 />, key: 'android', value: 'android' },
];

export const SELECT_OPTIONS = [
  {
    label: 'Notification',
    value: 'notification',
  },
  {
    label: 'Expanded Notification',
    value: 'expandedNotification',
  },
];

export const MAX_CHAR_LIMIT = {
  android: 45,
  ios: 150,
} as const;
